import React from "react";
import { Button } from "antd";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";

class AdvancedInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isToggle: false,
    };
  }

  onInputChange(name, value) {
    const values = this.state;
    values[name] = value;
    this.setState(values);
  }

  render() {
    const {
      label,
      placeholder,
      onChange,
      type,
      value,
      isPassword,
      disabled = false,
      date,
    } = this.props;
    const { isToggle } = this.state;

    return (
      <>
        {isPassword ? (
          <div className="advanced-input">
            <Button
              className="advanced-input__eye-toggle"
              type="text"
              icon={isToggle ? <EyeOutlined /> : <EyeInvisibleOutlined />}
              onClick={() => this.onInputChange("isToggle", !isToggle)}
            />
            <label className="advanced-input__label">
              {label}
              <input
                {...this.props}
                disabled={disabled}
                className="advanced-input__label__input"
                type={isToggle ? "text" : "password"}
                placeholder={placeholder}
                value={value}
                onChange={e => onChange(e.target.value)}
                data-inputmask={date ? "'alias': 'date'" : null}
              />
            </label>
          </div>
        ) : (
          <div className="advanced-input">
            <label className="advanced-input__label">
              {label}
              <input
                {...this.props}
                disabled={disabled}
                className="advanced-input__label__input"
                type={type || "text"}
                placeholder={placeholder}
                value={value}
                onChange={e => onChange(e.target.value)}
              />
            </label>
          </div>
        )}
      </>
    );
  }
}

export default AdvancedInput;
